// extracted by mini-css-extract-plugin
export default {"cls-1":"lura-care-logo-white_cls-1__MpoH5"};